import { type LucideProps } from 'lucide-react'

export default function Stripe(props: LucideProps) {
  return (
    <svg viewBox='0 0 12 16' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.94091 5.3779C4.94091 4.73522 5.46636 4.48804 6.33662 4.48804C7.58455 4.48804 9.16088 4.86705 10.4088 5.54269V1.67014C9.04594 1.12634 7.69949 0.912109 6.33662 0.912109C3.00334 0.912109 0.786621 2.65887 0.786621 5.57564C0.786621 10.1238 7.02627 9.39875 7.02627 11.3597C7.02627 12.1178 6.36946 12.365 5.44994 12.365C4.08707 12.365 2.34653 11.8047 0.967242 11.0466V14.9686C2.49431 15.6278 4.03781 15.9079 5.44994 15.9079C8.86532 15.9079 11.2134 14.2106 11.2134 11.2609C11.197 6.35015 4.94091 7.22353 4.94091 5.3779Z'
        fill='currentColor'
      />
    </svg>
  )
}
